import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastSeverity } from '#enums';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private messageService = inject(MessageService);

  showError(detail: string, summary = ''): void {
    this.messageService.add({
      detail,
      summary,
      sticky: true,
      closable: true,
      severity: ToastSeverity.Error,
    });
  }

  showWarning(detail: string, summary = '', life = 5000): void {
    this.messageService.add({
      detail,
      summary,
      severity: ToastSeverity.Warn,
      life,
    });
  }

  showSuccess(detail: string, summary = ''): void {
    this.messageService.clear();
    this.messageService.add({
      detail,
      summary,
      severity: ToastSeverity.Success,
    });
  }

  showInfo(detail: string, summary = '', life = 3000): void {
    this.messageService.add({
      detail,
      summary,
      life,
      severity: ToastSeverity.Info,
    });
  }
}
